import {
  initialState,
  PendingDeclinedServicesState,
  pendingDeclinedServicesAdapter
} from './pending-declined-services.interfaces';
import * as fromPendingDeclinedServices from './pending-declined-services.actions';
export function reducer(
  state = initialState,
  action: fromPendingDeclinedServices.PendingDeclinedServiceAction
): PendingDeclinedServicesState {
  switch (action.type) {
    case fromPendingDeclinedServices.ADD_PENDING_DECLINED_SERVICE_IN_STATE: {
      return {
        ...pendingDeclinedServicesAdapter.addOne(action.payload.serviceGroup, state)
      };
    }
    case fromPendingDeclinedServices.REMOVE_PENDING_DECLINED_SERVICE_IN_STATE: {
      return {
        ...pendingDeclinedServicesAdapter.removeOne(action.payload.id, state)
      };
    }
    case fromPendingDeclinedServices.CLEAR_PENDING_DECLINED_SERVICE_IN_STATE: {
      return initialState;
    }
    default: {
      return state;
    }
  }
}
